<i [ngClass]="'icon icon-' + icon + ((addBlur) ? ' blur' : '') " [attr.aria-label]=" 'Icon ' + ('ACCESSIBILITY.ICONS.' + icon | translate)"></i>
